import { render, staticRenderFns } from "./reviewExam.vue?vue&type=template&id=c90c94c2&scoped=true&"
import script from "./reviewExam.vue?vue&type=script&lang=js&"
export * from "./reviewExam.vue?vue&type=script&lang=js&"
import style0 from "./reviewExam.vue?vue&type=style&index=0&id=c90c94c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90c94c2",
  null
  
)

export default component.exports